const SupplyJoin = () => import('@/views/supply/supplyJoin')
const SupplyApply = () => import('@/views/supply/supplyApply')

export default {
  path: '/supply',
  name: 'supply',
  component: SupplyJoin,
  meta: {
    title: '供应商加盟',
    auth: false
  },
  children: [{
    path: '/supply/apply',
    name: 'supply_apply',
    component: SupplyApply,
    meta: {
      title: '供应商加盟申请',
      noHeader: true
    }
  }]
}
